<template>
<div>
    <!-- <b-card no-body class="bg-light"> -->


        <div v-if=showgraph>
            <TrafficHourPlot :key=myKey0 chartId="weekday" class="chart-wrapper" style="height:300px;margin-bottom:0px;" :period=period></TrafficHourPlot>
        </div>
        <!-- <div v-if=showtable>
      <TabulateTraffic :key=myKey class="chart-wrapper" style="margin-top:35px;" :period=period></TabulateTraffic>
    </div> -->

        <b-card-body class="pb-0">
            <!-- <b-button type="button" :pressed.sync="showtable" variant="outline-primary" class="float-right"><i class="icon-grid"></i></b-button>
            <b-button type="button" :pressed.sync="showgraph" variant="outline-primary" class="float-right"><i class="icon-graph"></i></b-button> -->
            <b-button-toolbar class="float-right" aria-label="Toolbar with buttons group">
                <b-form-radio-group class="mr-3" id="period" buttons button-variant="outline-secondary" v-model="period" name="period" @input="reload">
                    <b-form-radio class="mx-0" value="D">D</b-form-radio>
                    <b-form-radio class="mx-0" value="M">M</b-form-radio>
                    <b-form-radio class="mx-0" value="Y">Y</b-form-radio>
                </b-form-radio-group>
            </b-button-toolbar>
        </b-card-body>

    <!-- </b-card> -->
</div>
</template>

<script>
import TrafficHourPlot from './TrafficHourPlot';

export default {
    components: {
        TrafficHourPlot,

    },
    props: {},
    data() {
        return {
            period: 'M',
            myKey0: 0,
            showgraph: true,
            showtable: false,

        }
    },
    methods: {
        reload() {
            this.myKey0 += 1;
        },
    },

}
</script>
